//订单
const Common = {

    //公司类型
    Company_Inner: 1,
    Company_Major: 2,

    //公司标签
    Company_Inner_Config: [
        {'value': '院校', 'id': 201},
        {'value': '医院', 'id': 202},
        {'value': '车站', 'id': 203},
        {'value': '党政机关', 'id': 204},
        {'value': '物业', 'id': 205},
        {'value': '连锁门店', 'id': 207},
        {'value': '其它', 'id': 206},
    ],
    Company_Major_Config: [
        {'value': '维修公司', 'id': 301},
        {'value': '生产厂商', 'id': 302},
    ],

    //短信发送类型
    Verify_Code_Type: {
        'REGEST': 11,        //注册
        'FORGET_PWD': 12,    //忘记密码
        'LOGIN': 13,   //短信验证码登录
        'CHANGE_MOBILE': 21, //修改手机号
        'CHANGE_PWD': 22,   //修改密码
        'COMPLETE_INFO': 23, //补全信息
        'BIND_ACCOUNT': 24, //账号绑定
    },

    Module_Code: {
        'ORDER': 'ls101000',
        'COMPANY': 'ls601000',
        'SERVICER': 'ls700000',
        'ORDER_CREATE': 'ls102000',
        'ORDER_VIEW': 'ls101000',
        'VISITOR_INVITE': 'ls831000',
        'DEVICE': 'ls302000',
        'AUDIO': 'ls950000',
        'IMAGE': 'ls960000',
        'VIDEO': 'ls970000',
        'AREA': 'ls990000',
        'TAGS': 'ls603000',
        'FAULT': 'ls750000',
        'FAULT_PHENOMENON': 'ls615000',
        'BRAND': 'ls301000',
        'CUSTOM_ADDRESS': 'ls920000',
        'APPOINTMENT_TIME': 'ls930000',
        'DEPARTMENT': 'ls940000',
        'CUS_DEPARTMENT': 'ls941000',
        'ORDER_CHECK': 'ls132000',
        'DETAIL_ADDRESS': 'ls891000',

        'CONTENTUSER': 'ls893100',
        'CONTENTUSER_MOBILE': 'ls893200',
        'CONTENTUSER_PHONE': 'ls893300',
        'DESCRIPTION': 'ls892000',
        'SN': 'ls897100',
        'DIY_ONE': 'ls895100',
        'DIY_TWO': 'ls895200',
    },

    MobileWebApp_Source: {
        'WEIXIAO': 100113,      // 腾讯微校
    },

    // 故障类型记录限制
    Trouble_Describe_Record_Limit: 20,

}
export {Common}



// WEBPACK FOOTER //
// ./src/const/common.js